/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * DTO for a Localised String
 */
export interface LocalisedString {
  key?: string | null;
  parameters?: {
[key: string]: any | null;
};
  value?: string | null;
}

export class LocalisedString {
  key?: string | null;
  parameters?: {
[key: string]: any | null;
};
  value?: string | null;

  constructor(value: LocalisedString) {
    this.key = value?.key;
    this.parameters = value?.parameters;
    this.value = value?.value;
  }
}
